import img1 from '../Assets/our_services/2.svg';
import img2 from '../Assets/our_services/3.svg';
import img3 from '../Assets/our_services/4.svg';

const Products = [
    {
        img: img1,
        title: "E-commerce",
        link:"https://it-solutions-dynamic-leo-frontend.netlify.app/",
    },
    {
        img: img2,
        title: "Drop-shipping",
        link:"https://it-solutions-dynamic-leo-frontend.netlify.app/",
    },
    {
        img: img3,
        title: "IT-Solutions",
        link:"https://it-solutions-dynamic-leo-frontend.netlify.app/",
    }
];

export default Products;
